import React from "react";
import classes from "./EarringBackTooltip.module.css";

const EarringBackTooltip = () => {
  const earringBackTypes = [
    {
      title: "Butterfly Back",
      description:
             "A small metal clutch shaped like butterfly wings that slides onto a straight post. Classic and easy to use, ideal for everyday wear. Quick on and off.",
    },
    {
      title: "Screw Back",
      description:
             "Twists onto a threaded post like a tiny nut and bolt. Extra secure, great for active lifestyles.",
    },
    {
      title: "Guardian Back",
      description:
             "A smooth, push-on back with a hidden internal lock—designed to stay put. Premium security and comfort. Slides on with a locking mechanism, sleek and durable.",
    },
  ];

  return (
    <div className={classes.earringBackBody}>
      <div className={classes.contentContainer}>
        <p className={classes.introText}>
          We offer three styles of earring backs. Each has its own advantages.
        </p>

        {earringBackTypes.map(({ title, description }) => (
          <div key={title} className={classes.backTypeSection}>
            <h3 className={classes.backTypeTitle}>{title}</h3>
            <p className={classes.backTypeDescription}>{description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default EarringBackTooltip;
